// Financial Entries Management Permissions

export const FINANCIAL_ENTRIES_INDEX = 36;
export const FINANCIAL_ENTRIES_SHOW = FINANCIAL_ENTRIES_INDEX;
export const FINANCIAL_ENTRIES_CREATE = 37;
export const FINANCIAL_ENTRIES_EDIT = 38;
export const FINANCIAL_ENTRIES_DELETE = 39;
export const FINANCIAL_ENTRIES_PRINT = 1218;
